// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorMessage_errorMessage__Y5LCV","isSmall":"ErrorMessage_isSmall__mgfZT"};